import { render, staticRenderFns } from "./StudyInfoContainer.vue?vue&type=template&id=33da5d7d&scoped=true&"
import script from "./StudyInfoContainer.vue?vue&type=script&lang=js&"
export * from "./StudyInfoContainer.vue?vue&type=script&lang=js&"
import style0 from "./StudyInfoContainer.vue?vue&type=style&index=0&id=33da5d7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33da5d7d",
  null
  
)

export default component.exports